import { Component } from '@angular/core';
import { ModelUnion } from '@app/models/core/base.model';
import { Table } from '@app/modules/table/classes/table.class';
import { TableModule } from '@app/modules/table/table.module';
import { PlatformModule } from '@app/platform.module';
import { TranslateModule } from '@ngx-translate/core';
import { DentalBenefitService } from '../../services/dental-benefit/dental-benefit.service';
import { PayrollModuleMenuService } from '../../services/payroll-module-menu.service';
import { DentalBenefitsTable } from '../../services/tables/dental-benefits-table/dental-benefits.table';

@Component({
    templateUrl: './dental-benefit-index.template.html',
    imports: [PlatformModule, TranslateModule, TableModule],
    standalone: true,
})
export class DentalBenefitIndexView {
    isLoading = false;

    /**
     * I don't love doing this casting, but until we have a simplified version of our table, this keeps TS from flagging this as incorrectly typed.
     * Our table.class expects rows to always be Models, however, Models are often far more complex than necessary for a table (as in this case)
     */
    dentalBenefitsTable = this._dentalBenefitsTable as unknown as Table<ModelUnion>;

    constructor(
        public payrollModuleMenuService: PayrollModuleMenuService,
        private _dentalBenefitsTable: DentalBenefitsTable,
        dentalBenefitService: DentalBenefitService
    ) {
        // If the service has indicated count changes (via additions or removals to a code), we need to reload the table from the BE
        if (dentalBenefitService.haveCountChangesOccurred) {
            this.dentalBenefitsTable.reload();
            dentalBenefitService.haveCountChangesOccurred = false;
        }
    }
}
